// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Layout_layoutWrapper__9DaTH","menu":"Layout_menu__dyOYh","content":"Layout_content__UOgH6","fullContent":"Layout_fullContent__IHtGM"};